import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { SanctionEntity } from 'app/entities/monitoring/actual/sanction-matches.model';

@Component({
  templateUrl: './verify-now-dialog.component.html',
  styleUrls: ['./verify-now-dialog.component.css']
})
export class VerifyNowDialogComponent {
  results: SanctionEntity[] = [];
  errorMessage: string = '';
  loading = false;

  constructor(public dialogRef: MdDialogRef<VerifyNowDialogComponent>) {}

  get hasError(): boolean {
    return !!this.errorMessage;
  }

  get hasResults(): boolean {
    return !this.hasError && this.results && this.results.length > 0;
  }

  get noResults(): boolean {
    return !this.hasError && this.results && this.results.length === 0;
  }

  getDisplayName(se: SanctionEntity): string {
    return se.globalName || [se.firstName, se.middleName, se.lastName].filter(Boolean).join(' ') || '-';
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/dashboard/verify-now-dialog/verify-now-dialog.component.ts